module.exports = __webpack_public_path__ + "img/video.b967ef17.svg";